var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotePad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22208",
    x: 11.7459,
    y: 0.642291,
    width: 24.5354,
    height: 31.9013,
    rx: 4.5,
    transform: "rotate(20.2765 11.7459 0.642291)",
    stroke: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 355",
    d: "M13.3076 10.0662L26.8119 14.9769",
    stroke: "#E9E9E9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 356",
    d: "M10.8525 18.1694L24.3568 23.08",
    stroke: "#E9E9E9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 357",
    d: "M7.90625 25.5355L14.2901 27.9908",
    stroke: "#E9E9E9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePad);
export default __webpack_public_path__ + "static/media/NotePad.8bf0c6703962d569c72513475cd54431.svg";
export { ForwardRef as ReactComponent };